module.exports = __webpack_public_path__ + "img/40.50f67ae1.webp";